import axios from 'axios';

const state = {
  webConfig: {
    // stripePublicKey: "",
    appVersion: ""
  },
  // appConfig can be saved in local storage, the data will rarely change, usually with a new version. 
  appConfig: {
    permissions: [],
    accountSettings: {},
    entityTypes: [],
    idTypes: [],
    reportStatuses: [],
  }
}

const getters = {
  getPermissions: state => state.appConfig.permissions,
  // getStripePK: state => state.webConfig.stripePublicKey,
  // getPrices: state => includeTrial => {
  //     if(includeTrial){
  //         return state.webConfig.prices
  //     } else {
  //         return state.webConfig.prices.filter(price => price.id !== 'trial')
  //     }
  // },
  getAppVersion: state => {
    return state.webConfig.appVersion
  },
  getAccountSettings: state => state.appConfig.accountSettings,
  getEntityTypes: state => state.appConfig.entityTypes,
  getIdTypes: state => state.appConfig.idTypes,
  getReportStatuses: state => state.appConfig.reportStatuses

}

const actions = {
  async loadWebConfig({ commit }) {
    const response = await axios.get('/web/config')
    commit('setWebConfig', response.data)
  },
  async loadAppConfig({ commit, state }) {
    if (!state.appConfig.permissions || state.appConfig.permissions.length < 1) {
      const response = await axios.get('/api/config')
      commit('setAppConfig', response.data)
    }
  }
}

const mutations = {
  setWebConfig(state, webConfig) {
    state.webConfig = webConfig
  },
  setAppConfig(state, appConfig) {
    state.appConfig = appConfig
  },
  // For use by account store when compliance settings are updated.
  setAccountSettings(state, accountSettings) {
    state.appConfig.accountSettings = accountSettings
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}


